$('.download-list .row').click(function(event) {
    event.preventDefault();
    window.location.href = $(this).attr('data-file');
});


// WEBPACK FOOTER //
// ./js/contentelements/downloads.js